<template>
  <div class="logo-view">
    <el-image :src="logoUrl" class="home-logo"></el-image>
  </div>
</template>
<script>
export default {
  /**
   * logo组件
   */
  name: 'LogoView',
  props: {
    // 页面类型 值：home, login
    pageType: {
      type: String,
      default: 'home'
    }
  },
  data () {
    return {
      logoUrl: require('../assets/new_logo_v1.png')
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  },
  computed: {
  }
}
</script>
<style lang="scss">
  .logo-view {
    display: inline-block;
    height: 66px;
    vertical-align: middle;
    .home-logo {
      width: 314px;
      height: 66px;
      img {
        width: 134px;
        height: 66px;
        object-fit: contain;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LogoView.vue